// Konfigurasi dashboard Looker Studio per Bidang DKP Jawa Barat
export const DASHBOARDS = {
  PILAHSAR: {
    kode: "PILAHSAR",
    slug: "pilahsar",
    label: "PILAHSAR",
    title: "Dashboard PILAHSAR",
    subtitle: "Pembudidayaan Ikan, Pengolahan & Pemasaran",
    reportId: "cc98af02-784e-4cda-bb6a-bc0597bebb2c",
    pageId: "tv8XF",
    bidangSlug: "pembudidayaan-ikan-pengolahan-pemasaran",
  },
  TANGKAP: {
    kode: "TANGKAP",
    slug: "tangkap",
    label: "TANGKAP",
    title: "Dashboard Perikanan Tangkap",
    subtitle: "Bidang Perikanan Tangkap",
    reportId: "71efd950-3cac-4345-8ef2-562d8f068bcd",
    pageId: "fTvbF",
    bidangSlug: "perikanan-tangkap",
  },
  KELAUTAN: {
    kode: "KELAUTAN",
    slug: "kelautan",
    label: "KELAUTAN",
    title: "Dashboard Kelautan",
    subtitle: "Bidang Kelautan",
    reportId: "377dad41-7a4c-4524-b828-ef7bb5c835ef",
    pageId: "p_hydv4lfhwd",
    bidangSlug: "kelautan",
    gisMaps: [
      { label: "GIS Sebaran Garam", type: "iframe", url: "https://storymaps.arcgis.com/stories/fabeeb8359c14dda9eff84b2f7bc72ba" },
      { label: "GIS Konservasi", type: "iframe", url: "https://storymaps.arcgis.com/stories/aea003aeff274453909be2e0b7385287" },
    ],
  },
  PSDKP: {
    kode: "PSDKP",
    slug: "pengawasan",
    label: "PENGAWASAN",
    title: "Dashboard Pengawasan",
    subtitle: "Bidang Pengawasan Sumberdaya Kelautan dan Perikanan",
    reportId: "00baa5d9-a642-4e0b-8545-6e2e65d63022",
    pageId: "p_h6gmp649wd",
    bidangSlug: "pengawasan-sumberdaya-kelautan-perikanan",
  },
};

export function embedUrl(d) {
  return `https://lookerstudio.google.com/embed/reporting/${d.reportId}/page/${d.pageId}`;
}

export function viewUrl(d) {
  return `https://datastudio.google.com/u/0/reporting/${d.reportId}/page/${d.pageId}`;
}

export function findDashboardBySlug(slug) {
  return Object.values(DASHBOARDS).find((d) => d.slug === slug);
}

export function findDashboardByKode(kode) {
  return DASHBOARDS[kode] || null;
}
